<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Create Question Option</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Question Option Text Prompt</p>
      </div>

      <Form v-slot="{ handleSubmit, errors}" :validation-schema="schema" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <button v-if="questionOptionId" @click="destroy" type="button" class="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3">
          <TrashIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <div class="px-4 py-6 sm:p-8">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div class="sm:col-span-5">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900"></label>
              <div class="mt-2">
                <Field v-model="formData.text" v-bind:class="{ 'ring-red-600': errors.text }" type="text" name="text" id="text" placeholder="Text" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="text" />
              </div>
            </div>
            <div class="sm:col-span-5">
              <label for="max_score" class="block text-sm font-medium leading-6 text-gray-900">Value</label>
              <div class="mt-2">
                <Field v-model="formData.value" v-bind:class="{ 'ring-red-600': errors.value }" type="number" name="value" id="value" placeholder="Value" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="value" />
              </div>
            </div>
            <div class="sm:col-span-5">
              <label for="max_score" class="block text-sm font-medium leading-6 text-gray-900">Order</label>
              <div class="mt-2">
                <Field v-model="formData.order" v-bind:class="{ 'ring-red-600': errors.order }" type="number" name="order" id="order" placeholder="Order" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="order" />
              </div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button @click="cancel" type="button" class="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
          <button v-if="questionOptionId" @click="handleSubmit($event, update)" type="button" class="rounded-md network-bg-color px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Update</button>
          <button v-else @click="handleSubmit($event, create)" type="button" class="rounded-md network-bg-color px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Save</button>
        </div>

      </Form>
    </div>
  </div>
</template>

<script>
import { TrashIcon } from '@heroicons/vue/24/solid'

export default {
  name: "QuestionOptionCreateEditFormComponent",
  data() {
    return {
      formData: {
        text: null,
        value: null,
        order: null,
      },
    }
  },
  components: {
    TrashIcon,
  },
  computed: {
    questionOptionsGroupId() {
      return this.$route.params.question_options_group_id ? parseInt((this.$route.params.question_options_group_id)) : null;
    },
    questionOptionId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
    schema() {
      return yup.object({
        text: yup.string().required().min(3).label('Text'),
        value: yup.number().nullable().label('Value'),
        order: yup.number().required().label('Order'),
      });
    },
  },
  methods: {
    getOption() {
      axios.get(`/member-firm/question-option/edit/${this.questionOptionId}`).then((res) => {
        this.formData.text = res.data.data.text;
        this.formData.value = res.data.data.value;
        this.formData.order = res.data.data.order;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    update() {
      axios.put(`/member-firm/question-option/update/${this.questionOptionId}`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    create() {
      axios.post(`/member-firm/question-option/${this.questionOptionsGroupId}/store`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    cancel() {
      this.$router.back();
    },
    destroy() {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-option/destroy/${this.questionOptionsGroupId}`).then((res) => {
          this.$router.back();
        }).catch((error) => {
          console.log('error', error)
        })
      }
    },
  },
  mounted() {
    if (this.questionOptionId) {
      this.getOption();
    }
  }
}
</script>